module.exports = __webpack_public_path__ + "img/mobile-photo.f8a7b555.png";